import styled, {FlattenSimpleInterpolation, css} from 'styled-components'

export const StyledDropzone = styled.div`
    ${({dropzoneStyles}: {dropzoneStyles?: () => FlattenSimpleInterpolation}) => css`
        ${() => dropzoneStyles && dropzoneStyles()};
    `}
`
